import React from 'react'
import {Text} from 'react-form'
import {Grid, Row, Form, Col, FormGroup, Button} from 'react-bootstrap'
import ProgressBar from '../../Common/ProgressBar/ProgressBar'

import {MdLockOutline} from '../../Common/ReactIcons/icons'

export default ({submitForm, message, isLoading}) => {
  return (
    <Grid fluid className="ChangePassword">
      {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
      <Form horizontal onSubmit={submitForm}>
        <Row>
          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <MdLockOutline /> رمز عبور فعلی
            </Col>
            <Col sm={12} md={7}>
              <Text
                field="old_password"
                type="password"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <MdLockOutline /> رمز عبور جدید
            </Col>
            <Col sm={12} md={7}>
              <Text
                field="new_password"
                type="password"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} smOffset={0} mdOffset={4} md={7}>
              <Button type="submit" className={`btnBlock ${isLoading && 'disabled'}`} bsStyle="success">
                اعمال تغییرات
              </Button>
              <ProgressBar isLoading={isLoading} type="button" />
            </Col>
          </FormGroup>
        </Row>
      </Form>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/User/ChangePassword/ChangePasswordForm.js